module.exports = __webpack_public_path__ + "static/media/symbol-defs.5f0884b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/icons/symbol-defs.svg
// module id = 42
// module chunks = 0